function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { isEmptyArray } from '../../utils/ArrayUtils';
import styles from './CollapsibleList.less';
export var CollapsibleList = function CollapsibleList(_ref) {
  var items = _ref.items;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMore = _useState2[0],
    toggleShowMore = _useState2[1];
  if (isEmptyArray(items)) {
    return null;
  }
  var itemsToShow = showMore ? items : items.slice(0, 5);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, items && itemsToShow.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.link,
      "data-testid": "footer-link"
    }, /*#__PURE__*/React.createElement("a", {
      className: styles.footerLink,
      href: item.link
    }, item.name));
  }), items.length > 5 && /*#__PURE__*/React.createElement("button", {
    className: "link-text font-regular ".concat(styles.footerLink),
    type: "button",
    "aria-expanded": showMore,
    onClick: function onClick() {
      return toggleShowMore(!showMore);
    },
    style: {
      cursor: 'pointer'
    },
    "data-testid": "toggle-button"
  }, showMore ? /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "is24-icon-chevron-up margin-right-xs",
    "aria-hidden": "true"
  }), "Weniger anzeigen") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer"
  }, /*#__PURE__*/React.createElement("i", {
    className: "is24-icon-chevron-down margin-right-xs",
    "aria-hidden": "true"
  }), "Alle anzeigen"))));
};